import type { JSX } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from '@heroicons/react/24/outline';

import { APPLICATION_ARCH_TYPES, ARCHITECTURE_TYPE_LABELS, formatRefArchTitle } from '../utils';

interface RefArchBreadcrumbProps {
  architectureType: string;
  variant: string;
}

export function RefArchBreadcrumb({
  architectureType,
  variant,
}: RefArchBreadcrumbProps): JSX.Element {
  const tier = APPLICATION_ARCH_TYPES.includes(architectureType) ? 'application' : 'system';
  const tierLabel = tier === 'application' ? 'Application' : 'System';

  return (
    <nav className="flex items-center gap-1 text-sm text-muted mb-4" aria-label="Breadcrumb">
      <Link to="/patterns/architectures" className="hover:text-foreground transition-colors">
        Architectures
      </Link>
      <ChevronRightIcon className="h-3 w-3" />
      <Link
        to={`/patterns/architectures?tier=${tier}`}
        className="hover:text-foreground transition-colors"
      >
        {tierLabel}
      </Link>
      <ChevronRightIcon className="h-3 w-3" />
      <Link
        to={`/patterns/architectures?tier=${tier}&type=${architectureType}`}
        className="hover:text-foreground transition-colors"
      >
        {ARCHITECTURE_TYPE_LABELS[architectureType] ?? architectureType}
      </Link>
      <ChevronRightIcon className="h-3 w-3" />
      <span className="text-foreground font-medium">{formatRefArchTitle(variant)}</span>
    </nav>
  );
}
